import React from 'react';
import '../css/Button.css'
import { Link } from 'react-router-dom';

const StickyButton = () => {
  return (
    <Link to="/donation-details" className="button-label" dir="auto" data-qa="sticky-button-label">
      {/* DONATE NOW */}
      <b>देणगी</b> 
    </Link>
  );
};

export default StickyButton;
